module.exports = __webpack_public_path__ + "static/img/14.423d7cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/sp/14.png
// module id = 4Fyp
// module chunks = 0